import React from 'react';

const AudienceCityStatsComponent = ({ cityStats=[] }) => {
  return (
    <div>
      <h6> <strong>City</strong></h6>
      <div className="d-flex p-2 flex-column"
        style={{ height: '350px', overflow: 'scroll', gap: 8 }}>
        {
          cityStats.map((city, index) => {
            return (
              <div className='d-flex justify-content-between w-100 p-2'
                style={{ background: '#e1d6d6', borderRadius: '4px' }}>
                <div>{city.name}</div>
                <div>{city.value}</div>
              </div>
            );
          })
        }
      </div>
    </div>

  );
};

export default AudienceCityStatsComponent;
